import { useFlags } from 'launchdarkly-react-client-sdk';
import { addListener } from '@reduxjs/toolkit';
import { useEffect } from 'react';

import { sendAnalyticsInfo } from '../helpers';

import { useAppDispatch } from 'features/app/hooks';
import type { RootState, AppDispatch } from 'features/app/store/store';

const addAppListener = addListener.withTypes<RootState, AppDispatch>();

/** Log LD flags at the start of each call. Detected as "call ID changed." */
export function useLogLDFlags() {
  const flags = useFlags();
  const dispatch = useAppDispatch();

  useEffect(
    function setListener() {
      const unsubscribe = dispatch(
        addAppListener({
          predicate: (_, currentState, previousState) => {
            const isChanged = currentState.call.id !== previousState.call.id;
            const isSet = currentState.call.id > 0;
            return isSet && isChanged;
          },
          effect: (_action, listenerApi) => {
            listenerApi.dispatch(
              sendAnalyticsInfo({
                Method: 'useLogLDFlags',
                Message: 'Logging LD flags at the start of a call',
                Flags: flags,
              })
            );
          },
        })
      );
      return unsubscribe;
    },
    [dispatch, flags]
  );
}
